<template>
    <div>
        <el-tabs v-model="tabType">
            <el-tab-pane label="我的报告" name="mine">
                <div class="report-header">
                    筛选 : &nbsp;&nbsp;&nbsp;&nbsp;
                    <el-select v-model="dateValue" placeholder="请选择" size="small">
                        <el-option v-for="item in dateOption" :key="item.lessonId" :label="item.lessonName" :value="item.uid">
                        </el-option>
                        <el-pagination layout="prev, pager, next" :total="pageClass.total" :current-page="pageClass.page" :page-size="pageClass.limit" :pager-count="pageClass.pagerCount" @current-change="handPageClassChange"></el-pagination>
                    </el-select>
                </div>
            </el-tab-pane>
            <el-tab-pane v-if="isAdmin || isTeacher" label="批阅报告" name="review">
                <div class="report-header">
                    选择课堂 : &nbsp;&nbsp;&nbsp;&nbsp;
                    <el-select v-model="courseValue" placeholder="请选择" size="small">
                        <el-option v-for="item in courseOption" :key="item.lessonId" :label="item.lessonName" :value="item.uid"></el-option>
                        <el-pagination layout="prev, pager, next" :total="pageLesson.total" :current-page="pageLesson.page" :page-size="pageLesson.limit" :pager-count="pageLesson.pagerCount" @current-change="handPageLessonChange"></el-pagination>
                    </el-select>
                </div>
            </el-tab-pane>
            <component :is="tabs[tabType]" :data="data" @handleStartMark="handleStartMark" @submitReport="submitReport"/>
        </el-tabs>
        <el-pagination background prev-text="上一页" next-text="下一页" layout="total, prev, pager, next, jumper" :total="page.total" :current-page="page.page" :page-size="page.limit" :pager-count="page.pagerCount" @current-change="handPageChange" style="margin-top:15px" ></el-pagination>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import reportListMine from "./components/report-list-mine";
import reportListReview from "./components/report-list-review";
import { getLabExps,getMyReport } from "@/api/lab/experiment"
import { getMyList,getMyLesson } from "@/api/lab/lesson"
import { getStudentReports } from "@/api/lab/labexperiment2user"
import { open_blank } from '@/utils/router'


export default {
    data(){
        return {
            page:{
                page:1,
                limit:10,
                total:0
            },
            pageClass:{
                page:1,
                limit:5,
                total:0
            },
            pageLesson:{
                page:1,
                limit:5,
                total:0
            },
            data:[],
            tabs:{
                mine:'reportListMine',
                review:'reportListReview'
            },
            tabType:"mine",
            dateOption:[],
            courseOption:[],
            dateValue:'',
            courseValue:'',
        }
    },
    components:{
        reportListMine,
        reportListReview
    },
    computed:{
        ...mapGetters(['isAdmin', 'isTeacher','isStudent','userInfo'])
    },
    watch:{
        'tabType':{
            deep: true,
            immediate: true,
            handler:function(newVal){
                switch(newVal){
                    case 'mine':
                        this.getMyLesson()
                    break;
                    case 'review':
                        this.getMyList()
                    break;
                }
            }
        },
        courseValue(newVal){
            if(newVal){
                this.page = {
                    page:1,
                    limit:10,
                    total:0
                }
                this.getLabExps()
            }
        },
        dateValue(newVal){
            if(newVal){
                this.page = {
                    page:1,
                    limit:10,
                    total:0
                }
                this.getMyLabLesson()
            }
        }
    },
    methods:{
        getLabExps(){ 
            this.data = []
            const { page ,limit } = this.page
            let params = {
                lessonUid:this.courseValue,
                sidx:'view_index, create_time DESC'
            }
            getLabExps(page,limit,params).then(res=>{
                const { list,totalCount } = res
                this.data = list
                this.$set(this.page,'total',totalCount)
            })
        },
        getMyList(){  //批阅课堂列表
            const { page ,limit } = this.pageClass
            getMyList(page,limit,{status:1}).then(res=>{
                const { list , totalCount } = res
                this.courseOption = list
                this.$set(this.pageClass,'total',totalCount)
                if(this.courseOption) {
                    this.courseValue = list[0].uid
                    this.getLabExps()
                }
            })
        },
        getMyLesson(){  //我的报告课堂列表
            const { page ,limit } = this.pageLesson
            getMyLesson(page,limit,{status:1}).then(res=>{
                const { list , totalCount } = res
                this.dateOption = list
                this.$set(this.pageLesson,'total',totalCount)
                if(this.dateOption) {
                    this.dateValue = list[0].uid
                    this.getMyLabLesson()
                }
            })
        },
        getMyLabLesson(){  //我的报告课堂列表
            this.data = []
            const { page ,limit } = this.page
            const { id } = this.userInfo
            let params = {
                lessonUid:this.dateValue,
                targetId:id
            }
            getStudentReports(page,limit,params).then(res=>{
                const { list,totalCount } = res
                this.data = list
                this.$set(this.page,'total',totalCount)
            })
        },
        submitReport(row){
            const { uid } = row
            getMyReport(uid).then(uid => {
                open_blank({
                    name: 'lessonExpMarking',
                    params: { uid }
                })
            })
        },
        handPageChange(page){
            this.$set(this.page, 'page', page)
            this.getLabExps()
        },
        handPageClassChange(page){
            this.$set(this.pageClass, 'page', page)
            this.getMyList()
        },
        handPageLessonChange(page){
            this.$set(this.pageLesson, 'page', page)
            this.getMyLesson()
        },
        handleStartMark (data) {
            let lessonUid = this.courseValue
            const { uid } = data
            this.$router.push({ 'path': `/lesson/${lessonUid}/exp/${uid}` });
        },
    }
}
</script>
<style lang="less" scoped>
.report-header{
    margin: 20px;
}
    
</style>